import freeUserUpgradeBanner from "../../images/free-user-upgrade-banner.svg";
import freeUserUpgradeBannerTablet from "../../images/free-user-upgrade-banner-tablet.svg";
import freeUserUpgradeBannerMobile from "../../images/free-user-upgrade-banner-mobile.svg";

/**
 * Get the appropriate banner image based on screen size
 * @param {boolean} isMobile - Whether the screen is mobile size
 * @param {boolean} isTablet - Whether the screen is tablet size
 * @returns {string} - The appropriate banner image path
 */
export const getBannerImage = (isMobile, isTablet) => {
  if (isMobile) {
    return freeUserUpgradeBannerMobile;
  } else if (isTablet) {
    return freeUserUpgradeBannerTablet;
  } else {
    return freeUserUpgradeBanner;
  }
};
